import { render, staticRenderFns } from "./PsCalendarUpperBar.vue?vue&type=template&id=9f8b6a60&scoped=true&"
import script from "./PsCalendarUpperBar.vue?vue&type=script&lang=js&"
export * from "./PsCalendarUpperBar.vue?vue&type=script&lang=js&"
import style0 from "./PsCalendarUpperBar.vue?vue&type=style&index=0&id=9f8b6a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8b6a60",
  null
  
)

export default component.exports